<div class="dialog">
  <h3>Filter strelcev</h3>
  <form (ngSubmit)="onApply()">
    <label>
      Šifra strelca:
      <input type="number" [(ngModel)]="filters.member_id" name="member_id">
    </label>
    <label>
      Ime strelca:
      <input type="text" [(ngModel)]="filters.full_name" name="full_name">
    </label>
      <label>
      Spol:
      <select [(ngModel)]="filters.gender" name="gender">
        <option value="">-- izberi --</option>
        <option value="M">M</option>
        <option value="Ž">Ž</option>
      </select>
    </label>
    <label>
      Ime kluba:
      <input type="text" [(ngModel)]="filters.club_name" name="club_name">
    </label>
    <label>
      Koda kluba:
      <input type="text" [(ngModel)]="filters.club_code" name="club_code">
    </label>
    <div class="dialog-actions">
      <button type="submit">Uporabi</button>
      <button type="button" (click)="onReset()">Ponastavi</button>
    </div>
  </form>
</div>